import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { UserPermissionsService } from 'src/app/shared/services/user-permissions.service';
import { SessionService } from 'src/app/shared/services/session.service';
import fscreen from 'fscreen';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit, OnDestroy {
    avatar = '../../../assets/images/profile-pics/8.jpg';
    hasFullscreenSupport: boolean = fscreen.fullscreenEnabled;
    isFullscreen: boolean;
    userData: any;
    role = this.sessionService.role;
    id = this.sessionService.id;

    constructor(
        private location: Location,
        private sessionService: SessionService,
        private userPermissionsService: UserPermissionsService
    ) {}

    ngOnInit() {
        this.getUserInfo();
        if (this.hasFullscreenSupport) {
            fscreen.addEventListener(
                'fullscreenchange',
                () => {
                    this.isFullscreen = fscreen.fullscreenElement !== null;
                },
                false
            );
        }
    }

    getUserInfo(): any {
        this.userPermissionsService.readTokenData().subscribe(
            response => {
                if (response) {
                    this.sessionService.id = response.id;
                    this.userData = response;
                    if (response.foto) {
                        this.avatar = response.foto;
                    }
                }
            },
            error => console.error(error)
        );
    }

    ngOnDestroy() {
        if (this.hasFullscreenSupport) {
            fscreen.removeEventListener('fullscreenchange');
        }
    }

    toggleFullscreen() {
        if (this.hasFullscreenSupport && !this.isFullscreen) {
            const elem = document.body;
            fscreen.requestFullscreen(elem);
        } else {
            fscreen.exitFullscreen();
        }
    }

    // NOTE Encerra sessao e envia para a tela de login do tipo de usuario
    logOff(): void {
        this.sessionService.logOff();
    }
}
